<template>
    <div  class="page--como-participar d-flex align-items-start justify-content-center flex-column">
        <b-container>
            <h1>Como Participar</h1>
            <b-row class="d-flex justify-content-center align-items-top" id="parent-to-motion--como_participar">
                <b-col
                    class="d-flex justify-content-top align-items-center flex-column opacity0"
                    cols="12" md="4">
                    <picture>
                        <source media="(min-width:320px)" srcset="absoluto/assets/images/como-participar/como-participar-1.webp?t=2">
                        <img src="absoluto/assets/images/como-participar/como-participar-1.webp?t=2"
                        :alt='Passo1'
                        :title='Passo1'
                        />
                    </picture>
                </b-col>

                <b-col
                    class="d-flex justify-content-top align-items-center flex-column opacity0 mt-5 mt-md-0"
                    cols="12" md="4">
                        <a @click="$router.push({ path: `/login` })">
                            <picture>
                                <source media="(min-width:320px)" srcset="absoluto/assets/images/como-participar/como-participar-2.webp?t=2">
                                <img src="absoluto/assets/images/como-participar/como-participar-2.webp?t=2"
                                :alt='Passo2'
                                :title='Passo2'
                                />
                            </picture>
                        </a>
                </b-col>
                <b-col
                    class="d-flex justify-content-top align-items-center flex-column opacity0 mt-5 mt-md-0"
                    cols="12" md="4">
                    <picture>
                        <source media="(min-width:320px)" srcset="absoluto/assets/images/como-participar/como-participar-3.webp?t=2">
                        <img src="absoluto/assets/images/como-participar/como-participar-3.webp?t=2"
                        :alt='Passo3'
                        :title='Passo3'
                        />
                    </picture>
                </b-col>
            </b-row>
            <b-row class="mt-md-5 mb-5 extra">
                <b-col cols="12" md="12" class="d-flex justify-content-center align-items-center flex-column mt-5 mt-md-0">
                    <picture>
                        <source media="(min-width:768px)" srcset="absoluto/assets/images/como-participar/dobro.webp?t=2">
                        <source media="(min-width:320px)" srcset="absoluto/assets/images/como-participar/dobro-mob.webp?t=2">
                        <img src="absoluto/assets/images/como-participar/dobro.webp?t=2" :alt='extra' :title='extra'>
                    </picture>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: "ComoParticipar",
        data() {
            return {
                Passo1: '1) Compre um produto participante.',
                Passo2: '2) Cadastre sua nota fiscal aqui no site.',
                Passo3: '3) Concorra a prêmios incríveis.',
                extra: 'Compre produtos selecionados e ganhe o dobro de chances'
            };
        },
        mounted() {
        },
        methods : {
        }
    };
</script>
<style lang="scss" scoped>
    @import "../assets/scss/global";
    @import "../assets/scss/onepage";

    // .page--como-participar {

    // }

    @media (max-width: $mobile) , (orientation:portrait) {
        .page--como-participar {

            .row{
                flex-flow: column;
                align-items:center;
                justify-content: flex-start;
                max-width: 90%;
                margin-left: auto;
                margin-right: auto;
                img{
                    max-width: 85% !important;
                }
                div:nth-child(2) {
                    margin: 3rem 0 0 !important;
                }
            }
        }
    }

    // @media (max-width: 540px) {
    //     .page--como-participar {

    //     }
    // }

    @media (max-height:700px) and (orientation: landscape) {

        // .page--como-participar {

        // }

    }
</style>
